import Vue from 'vue';
import {HTTP} from '@/utils/httpCommonUtil';
import {BallPulseLoader} from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner';
import GenericModal from '@/componentsReusable/genericModal.vue';
import {UserRoleEnum} from '@/enums/userRolesEnum';
import ShiftEventHub from '@/components/shift/ShiftEventHub';
import HttpMixin from '@/mixins/HttpMixin';

export default Vue.component('shift-provider-info-card', {
  name: 'ShiftProviderInfoCard',
  data () {
    let emptyArray: Array<any> = [];
    return {
      cardExpanded: false,
      isAuthorizedToDelete: false,
      shiftProviderInfos: emptyArray,
      showConfirmationModal: false,
      pendingRemoveProviderShiftInfo: null,
      pendingFacilitySpecialty: null,
      requestingShift: false,
      showConfirmRequestShift: false
    }
  },
  components: {
    BallPulseLoader,
    VueSimpleSpinner,
    GenericModal
  },
  mixins: [ HttpMixin ],
  computed: {
    isProviderUser (): boolean {
      return this.$store.getters['user/hasOnlyRole'](UserRoleEnum.PROVIDER)
    },
    isFacilityUser (): boolean {
      return this.$store.getters['user/hasOnlyRole'](UserRoleEnum.FACILITY_CONTACT)
    }
  },
  beforeMount: function () {
    this.isAuthorizedToDelete = this.$store.getters['user/hasRole']([UserRoleEnum.MANAGER]);
  },
  created: function () {
    this.expandCard();
  },
  filters: {
    nickname (nickName: string ) {
      if (nickName && nickName.length) {
        return '(' + nickName + ')';
      }
      return '';
    },
    paysMileage (paysMileage: boolean ) {
      return paysMileage ? 'Yes' : 'No';
    },
    title (title: string ) {
      if (title && title.length) {
        return ' | ' + title;
      }
      return '';
    },
    phoneNumber (phoneNumber: string) {
      let formattedPhoneNumber = phoneNumber;
      if (phoneNumber && phoneNumber.length) {
        let phoneNumberArray = phoneNumber.match(/(\d)?(\d\d\d)?(\d\d\d)(\d\d\d\d)$/);
        if (!phoneNumberArray) { return formattedPhoneNumber; }
        formattedPhoneNumber = phoneNumberArray.length ? '' : formattedPhoneNumber;
        for (let i = 1; i < phoneNumberArray.length; i++) {
          if (phoneNumberArray[i]) {
            formattedPhoneNumber += phoneNumberArray[i] + '.';
          }
        }
        formattedPhoneNumber = formattedPhoneNumber.slice(0,formattedPhoneNumber.length - 1);
      } else {
        formattedPhoneNumber = 'NA';
      }
      return formattedPhoneNumber;
    }
  },
  methods: {
    expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        this.getShiftProviderInfo()
      }
    },
    getShiftProviderInfo () {
      let self = this as any;
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      HTTP.get('/api/shifts/' + this.$route.params.shiftId + '/shift-provider-info')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving Shift Provider Information.");
        }
        let freshShiftProviderInfos = response.data.data;
        freshShiftProviderInfos.forEach( function (shiftProviderInfo: any) {
          shiftProviderInfo.isEditing = false;
          shiftProviderInfo.isViewing = true;
          shiftProviderInfo.updatingData = false;
        });

        self.shiftProviderInfos = freshShiftProviderInfos;
      })
      .catch(function (err) {
        console.log('response Error!');
        console.log(err);
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Shift Provider Info.'
        });
      })
    },
    toggleEditFacility (shiftProviderInfo: any) {
      if (this.isProviderUser || this.isFacilityUser) {
        return;
      }
      shiftProviderInfo.isEditing = !shiftProviderInfo.isEditing;
    },
    removeConfirmed (id: any) {
      this.showConfirmationModal = false;
      this.removeProvider(this.pendingRemoveProviderShiftInfo, true);
    },
    removeProvider (shiftProviderInfo: any, bypassDeleteConfirmation: boolean = false) {
      if (!bypassDeleteConfirmation) {
        // Show Delete Confirmation Modal
        this.showConfirmationModal = true;
        this.pendingRemoveProviderShiftInfo = shiftProviderInfo;
        return;
      } else {
        this.pendingRemoveProviderShiftInfo = null;
      }

      let self = this
      shiftProviderInfo.updatingData = true;
      HTTP.delete('/api/shifts/' + shiftProviderInfo.shiftId + '/providers/' + shiftProviderInfo.providerId)
      .then(function (response) {
        shiftProviderInfo.updatingData = false;

        // Broadcast, to whoever is listening, that a new a provider has been added or removed from the shift.
        ShiftEventHub.$emit('SHIFT_PROVIDER_CHANGE');

        self.expandCard();
        self.$notify({
          group: 'main',
          type: 'success',
          title: 'Successfully Removed Provider',
          text: 'You successfully removed the Provider from this Shift.',
        });
      })
      .catch(function () {
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error Removing Provider',
          text: 'Something went wrong removing this Provider.',
        });
      })
    },
    browseToProvider (facspec: any, bypassBrowseConfirmation: boolean = true) {
      if (!bypassBrowseConfirmation) {
        // Show Browse Confirmation Modal
        this.showConfirmationModal = true;
        this.pendingFacilitySpecialty = facspec;
        return;
      } else {
        this.pendingFacilitySpecialty = null;
      }

      window.open("/providers/" + facspec.providerId, '_blank');
    },
    onCopy (param: any) {
      this.$notify({
        group: 'main',
        type: 'success',
        title: 'Successfully Copied',
        text: 'Your selected text ' + param.text + ' has been copied.',
      });
    },
    onError (param: any) {
      console.log('Error!');
      console.log(param);
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error Copying',
        text: 'Something went wrong copying to your clipboard.',
      });
    },
    requestShift () {
      this.showConfirmRequestShift = true;
    },
    async sendShiftRequest () {
      this.showConfirmRequestShift = false;
      const shiftId = this.$route.params.shiftId;
      const providerId = this.$store.state.user.providerId;
      const results = await (this as any).httpPost(`/shifts/${shiftId}/providers/${providerId}/request`, 'Error while requesting Shift');
      if (results) {
        this.$notify({
          group: 'main',
          type: 'success',
          title: 'Success',
          text: 'Sent an email to NMR requesting Shift.'
        });
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/shift/cards/providerInfo/ShiftProviderInfoCard.ts